<template>
  <v-container class="px-0 py-0 mb-n3 d-flex" fluid>
    <v-spacer></v-spacer>
    <v-switch
      v-model="status"
      label="Auto-complete on status"
      @click="changeSubrouteStatus"
    ></v-switch>
    <v-btn
      class="mx-2"
      fab
      color="grey lighten-1 grey-darken-1--text"
      style="width: 20px; height: 20px; margin-top: 21px;"
      elevation="0"
      @click="dialog = true"
    >
      ?
    </v-btn>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-text class="pt-5">
          The "Auto-complete on status" switch will set this route as
          <b>"Done"</b> automatically when the progress of this route becomes
          100% (This will take place when the user who created this route accept
          the last route status).
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
  export default {
    name: "SubRouteFooter",
    props: {
      routeId: Number,
      parentRouteId: Number,
      isChild: Boolean,
      currentStatus: Boolean
    },
    data() {
      return {
        status: false,
        dialog: false,
      };
    },
    methods: {
      ...mapActions(['updateRouteAutoComplete', 'updateSubRouteAutoComplete']),
      async changeSubrouteStatus() {
        let response;
        let body = {
          status: this.status,
          route_id: this.routeId
        }

        if(!this.isChild) {
          body.container = this.parentRouteId;

          response = await this.updateRouteAutoComplete(body)
        } else {
          response = await this.updateSubRouteAutoComplete(body);
        }

        if(response) console.log('true');
      },
    },
    mounted() {
      this.status = this.currentStatus;
    }
  };
</script>

<style></style>
